// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-line';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm16.75 3.5a1.75 1.75 0 1 1-.514 3.423l-4.14 6.209a1.75 1.75 0 0 1-2.622 2.316l-3 1.499a1.75 1.75 0 1 1-.448-.894l3-1.501a1.75 1.75 0 0 1 2.236-1.976l4.141-6.209A1.75 1.75 0 0 1 16.75 3.5Zm-12 13a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-9a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z' />
);

export const viewBox = '0 0 22 22';
